import { Button, SxProps, Theme } from '@mui/material';
import React from 'react';

interface BookingFormButtonProps {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
  [key: string]: any;
}

const BookingFormButton: React.FC<BookingFormButtonProps> = ({ children, sx = {}, ...props }) => (
  <Button
    fullWidth
    sx={{
      height: "48px",
      borderRadius: "24px",
      background: '#D29B5F',
      fontWeight: 700,
      fontSize: 18,
      color: '#fff',
      marginTop: "32px",
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 1,
      '&:hover': {
        background: '#b07d3e',
      },
      ...sx,
    }}
    {...props}
  >
    {children}
  </Button>
);

export default BookingFormButton; 